import { getBNXGNUserService } from '@/api'

export const bindUserMixin = {
  data() {
    return {
      // 绑定的状态结果
      bindResult: {
        havePrivilege: false,
        match: false,
        ylykIsHavePirvilege: false
      }
    }
  },
  methods: {
    // 用户是否有新概念课程权益
    async do$checkUserCoursePrivilege(data, bindResult) {
      try {
        const userCourse = await getBNXGNUserService.checkUserCoursePrivilege(data)
        this.bindResult.havePrivilege = userCourse.havePrivilege
        // 2022年06月10日新增 暴虐用户信息  在页面展示,方便查询
        this.bindResult.userId = userCourse.userId
        this.bindResult.nickName = userCourse.nickName
      } catch ({ code, message }) {
        bindResult.havePrivilege = -1
        if (code === 80007) {
          bindResult.resultText = '暴虐新概念公众号授权中'
          bindResult.codeIsError = true // 公众号需要重新授权
        } else {
          bindResult.resultText = message
        }
      }
      if (bindResult.havePrivilege === false) {
        bindResult.resultText = '无新概念课程权益'
      }
    },
    // 新概念是否有匹配的友邻少年ID
    async do$isMatchYlyk(data, bindResult) {
      try {
        const isMatchYlyk = await getBNXGNUserService.isMatchYlyk(data)
        bindResult.match = isMatchYlyk.match
      } catch ({ code, message }) {
        bindResult.resultText = message
      }
    },
    // 对应友邻少年ID是否有相应权益
    async do$ylykIsHavePirvilege(data, bindResult) {
      try {
        const ylykIsHavePirvilege = await getBNXGNUserService.ylykIsHavePirvilege(data)
        const { havePrivilege } = ylykIsHavePirvilege
        bindResult.ylykIsHavePirvilege = havePrivilege
        if (havePrivilege) {
          bindResult.resultText = '已绑定课程权益'
          bindResult.resultSuccess = true
        }
      } catch ({ code, message }) {
        bindResult.resultText = message
      }
    },
    // 添加新概念权益
    async do$addPrivilege(data, bindResult) {
      try {
        await getBNXGNUserService.addPrivilege(data)
        bindResult.resultText = '恭喜您已迁移成功'
        bindResult.resultSuccess = true
      } catch ({ code, message }) {
        if (code === 80012) {
          bindResult.resultText = message // '账号已冻结，迁移失败'
        } else if (code === 80009 || code === 80011) {
          bindResult.ylykUserStatus = -11 // 账户不存在 或 已销户
          bindResult.resultText = message // '账户不存在或已销户'
        } else {
          bindResult.resultText = message
        }
        bindResult.resultObject = { code, message }
        bindResult.resultSuccess = null
      }
    },
    // 绑定手机号后添加新概念权益
    async do$bindAndAddPrivilege(data, bindResult) {
      try {
        await getBNXGNUserService.bindAndAddPrivilege(data)
        bindResult.resultSuccess = true
        bindResult.resultText = '恭喜您已迁移成功'
      } catch ({ code, message }) {
        bindResult.resultSuccess = false
        bindResult.resultText = message
      }
    }
  }
}
